import chroma from 'chroma-js';
import Colors from 'common/constants/colors';

export const getColorBasedOnContrast = (color) => {
  // Incoming color could be hex or rgba
  const hex = chroma(color).hex().split('#').pop();

  // Pilfered from https://24ways.org/2010/calculating-color-contrast/
  const red = parseInt(hex.substr(0, 2), 16);
  const green = parseInt(hex.substr(2, 2), 16);
  const blue = parseInt(hex.substr(4, 2), 16);
  const yiq = (red * 299 + green * 587 + blue * 114) / 1000;
  return yiq >= 128 ? Colors.gray800 : Colors.white;
};

export const getSecondary = (primary) => {
  return chroma(primary).brighten(0.95).hex();
};
